import {
  DoubleLeftOutlined,
  DoubleRightOutlined,
  LeftOutlined,
  RightOutlined,
} from '@ant-design/icons';
import { Space } from 'antd';
import SelectMonth from './select-month';
import SelectYear from './select-year';
import { formatDate, parseDateString } from './utils';

const UPPER_LIMIT = 2099;
const LOWER_LIMIT = 1970;

interface Props {
  localDate: string;
  onChange: (date: string) => void;
}

const CalendarHeader: React.FC<Props> = (props) => {
  const { localDate, onChange } = props;
  const [year, month, date] = parseDateString(localDate);

  const canGoToPreviousYear = year > LOWER_LIMIT;
  const canGoToNextYear = year < UPPER_LIMIT;
  const canGoToPreviousMonth = year > LOWER_LIMIT || month > 1;
  const canGoToNextMonth = year < UPPER_LIMIT || month < 12;

  const goToNextYear = () => onChange(formatDate(year + 1, month, date));
  const goToPreviousYear = () => onChange(formatDate(year - 1, month, date));

  const goToPreviousMonth = () => {
    const newMonth = month === 1 ? 12 : month - 1;
    const newYear = month === 1 ? year - 1 : year;
    onChange(formatDate(newYear, newMonth, date));
  };

  const goToNextMonth = () => {
    const newMonth = month === 12 ? 1 : month + 1;
    const newYear = month === 12 ? year + 1 : year;
    onChange(formatDate(newYear, newMonth, date));
  };

  const onMonthChange = (newMonth: number) =>
    onChange(formatDate(year, newMonth, date));
  const onYearChange = (newYear: number) =>
    onChange(formatDate(newYear, month, date));

  const clickableStyle = 'cursor-pointer';
  const disabledStyle = 'cursor-not-allowed text-[#BFBFBF]';

  return (
    <div className="flex justify-between mx-1">
      <Space>
        <DoubleLeftOutlined
          className={`${canGoToPreviousYear ? clickableStyle : disabledStyle}`}
          onClick={canGoToPreviousYear ? goToPreviousYear : undefined}
        />
        <LeftOutlined
          className={`${canGoToPreviousMonth ? clickableStyle : disabledStyle}`}
          onClick={canGoToPreviousMonth ? goToPreviousMonth : undefined}
        />
      </Space>

      <Space.Compact>
        <SelectMonth value={month} onChange={onMonthChange} />
        <SelectYear value={year} onChange={onYearChange} />
      </Space.Compact>

      <Space>
        <RightOutlined
          className={`${canGoToNextMonth ? clickableStyle : disabledStyle}`}
          onClick={canGoToNextMonth ? goToNextMonth : undefined}
        />
        <DoubleRightOutlined
          className={`${canGoToNextYear ? clickableStyle : disabledStyle}`}
          onClick={canGoToNextYear ? goToNextYear : undefined}
        />
      </Space>
    </div>
  );
};

export default CalendarHeader;
